import MainSection from '../components/mainSection/MainSection';
// import ProductsGrid from '../components/productsGrid/ProductsGrid';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ProductsCard from '@/features/homePage/components/products/ProductsCard';

export default function ProductsPage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('meta.productsTitle')}</title>
                <meta name="description" content={t('meta.productsDesc')} />
                <link rel="canonical" href="/products" />
            </Helmet>
            <MainSection />
            <div className="w-full mb-[80px] relative overflow-hidden mainContainer">
                {/* <ProductsGrid /> */}
                <ProductsCard />
            </div>
        </>
    );
}
